import React from "react";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { LinearProgress } from "@mui/material";
import CustomToolBar from "../../../../components/global/CustomToolBar.jsx";

const BoardDataGrid = React.memo(
  ({
    rows,
    columns,
    apiRef,
    filterModel,
    onFilterModelChange,
    columnVisibilityModel,
    onColumnVisibilityModelChange,
    pinnedColumns,
    onPinnedColumnsChange,
    onCellEditStop,
    checkboxSelection,
    initialState,
    onRowSelectionModelChange,
    onClipboardCopy,
    isLoadingRows,
    pathname,
    updateBoard,
    selectedView,
  }) => (
    <DataGridPro
      rows={rows}
      rowHeight={40}
      headerHeight={40}
      columns={columns}
      getRowId={(row) => row.id ?? row.offerID}
      style={{
        position: "relative",
        maxWidth: "100%",
        height: isLoadingRows ? "175px" : "100%",
      }}
      columnBuffer={1}
      columnThreshold={1}
      components={{
        LoadingOverlay: LinearProgress,
      }}
      loading={isLoadingRows}
      filterModel={filterModel}
      onFilterModelChange={onFilterModelChange}
      slots={{
        toolbar: () => (
          <CustomToolBar
            apiRef={apiRef}
            pathname={pathname}
            updateBoard={updateBoard}
            selectedView={selectedView}
          />
        ),
        loadingOverlay: LinearProgress,
      }}
      columnVisibilityModel={columnVisibilityModel}
      onColumnVisibilityModelChange={onColumnVisibilityModelChange}
      pinnedColumns={pinnedColumns}
      onPinnedColumnsChange={onPinnedColumnsChange}
      onCellEditStop={onCellEditStop}
      disableRowSelectionOnClick
      checkboxSelection={checkboxSelection}
      initialState={initialState}
      apiRef={apiRef}
      onRowSelectionModelChange={onRowSelectionModelChange}
      onClipboardCopy={onClipboardCopy}
    />
  )
);

export default BoardDataGrid;
